module.exports = __webpack_public_path__ + "img/Starter.97daafb9.png";